import React, { FC, useContext } from 'react';

import { AppContext } from '@src/providers/App';
import { IPageWrapperProps } from './models';

/** Компонент для донастройки страницы */
export const PageWrapper: FC<IPageWrapperProps> = ({ href, titleParam = '', children, metaContentMap }) => {
  const { pagesCache, nextComponent } = useContext(AppContext);
  const htmlProps = pagesCache?.getProps(href);

  if (!htmlProps || !nextComponent) {
    console.error(
      `Компонент PageWrapper вернул null. Это могло произойти по некоторым причинам.
        1. Не передан Head from 'next/head" в AppProvider.
        2. Не найдены htmlProps для этого роута в pagesCache, который вы также передаете в AppProvider`,
    );
    return null;
  }

  return (
    <>
      <nextComponent.Head>
        <title>{typeof htmlProps.title === 'function' ? htmlProps.title(titleParam) : htmlProps.title}</title>
        {Array.isArray(htmlProps.meta) &&
          htmlProps.meta.map((m) => {
            let content = typeof m.content === 'function' ? m.content(titleParam) : m.content;

            if (metaContentMap?.hasOwnProperty(m.name)) {
              content = metaContentMap[m.name];
            }

            const metaProps = {
              name: m.name,
              content,
            };

            if (m.name === 'og:image' && m.imageSize && content.length > 0) {
              return (
                <>
                  <meta key={m.name} property={m.name} content={content} />
                  <meta key={`${m.name}:width`} property="og:image:width" content={String(m.imageSize.width)} />
                  <meta key={`${m.name}:height`} property="og:image:height" content={String(m.imageSize.height)} />
                </>
              );
            }

            return <meta key={m.name} {...metaProps} />;
          })}
      </nextComponent.Head>
      {children}
    </>
  );
};
